import React from "react";

const ColorModeContext = React.createContext({
  colorMode: {
    toggleColorMode: () => {},
    setPrimaryColorLight: (_) => {},
    setPrimaryColorDark: (_) => {},
    setAppLogoLight: (_) => {},
    setAppLogoDark: (_) => {},
    setAppLogoFavicon: (_) => {},
    setAppName: (_) => {},
    appLogoLight: null,
    appLogoDark: null,
    appLogoFavicon: null,
    appName: "",
    mode: "light",
    primaryColorLight: "#0000FF",
    primaryColorDark: "#39ACE7",
  }
});

export default ColorModeContext;
